import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { rolesSlice } from "../app/modules/UserManagement/_redux/roles/rolesSlice";
import { usersSlice } from "../app/modules/UserManagement/_redux/users/usersSlice";
import { eventsSlice } from "../app/modules/Settings/_redux/events/eventsSlice";
import { professionalsSlice } from "../app/modules/Settings/_redux/professionals/professionalsSlice";
import { settingsSlice }from "../app/modules/Settings/_redux/system/settingsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  roles: rolesSlice.reducer,
  users: usersSlice.reducer,
  settings: settingsSlice.reducer,
  events: eventsSlice.reducer,
  professionals: professionalsSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
